import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { AppScopeProvider } from 'v5/core/app-scope/_private/AppScopeProvider';

/**
 * Public shortlists render for anonymous visitors, so the organization comes
 * from the URL — the session that normally feeds GlobalAppScopeProvider is
 * absent here.
 */
export function PublicShortlistAppScope({ children }: { children: ReactNode }) {
  const { app_id } = useParams<{ app_id: string }>();

  return (
    <AppScopeProvider scope={{ level: 'organization', organizationId: app_id }}>
      {children}
    </AppScopeProvider>
  );
}
